export const Partners = {
  CARVANA: 'carvana',
};
